import React, { useState, useEffect } from "react";
import { Trans } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import Divider from "@material-ui/core/Divider";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import TeamAutosuggest from "../components/TeamAutosuggest";
import { taxServiceClient } from "../AxiosClient";

function TeamPicker(props) {
  const [teams, setTeams] = useState([]);
  const [teamUsers, setTeamUsers] = useState([]);

  useEffect(
    () => {
      props.onTeamUsersUpdate(teams);
    },
    [teams]
  );

  const removeTeam = (team) => {
    setTeams(teams.filter((ele) => ele.teamName !== team.teamName));
  };

  const addTeam = (team) => {
    if (!teams.includes(team)) {
      setTeams([...teams, team]);
      taxServiceClient.get(`/team/${team.teamId}/users`).then((res) => {
        setTeamUsers([...teamUsers, ...res.data.content.map((ele) => ele)]);
      });
    }
  };

  return (
    <>
      <div style={{ marginBottom: 10 }}>
        {props.asChips && (
          <FormControl>
            <div style={{ marginTop: 10, marginBottom: 10 }}>
              {teams.length === 0 && (
                <Typography color="textSecondary" style={{ marginBottom: 10 }}>
                  <Trans i18nKey="team_picker_no_teams_selected" />
                </Typography>
              )}
              {teams.map((team) => (
                <Chip
                  style={{ margin: 2 }}
                  onDelete={() => removeTeam(team)}
                  label={team.teamName + " (team)"}
                />
              ))}
            </div>
          </FormControl>
        )}
        <div>
          <TeamAutosuggest getListOfFilterTaxonomyIds={props.getListOfFilterTaxonomyIds} onItemSelected={addTeam} clearOnSelect />
        </div>
        {!props.asChips && (
          <Paper>
            {teams.length === 0 && (
              <Typography style={{ textAlign: "center", marginTop: 15 }}>
                <Trans i18nKey="team_picker_no_teams_selected" />
              </Typography>
            )}
            <List>
              {teams.map((ele) => {
                return (
                  <>
                    <ListItem>
                      <ListItemText primary={ele.teamName} secondary="Team" />
                      <ListItemSecondaryAction>
                        <IconButton onClick={() => removeTeam(ele)}>
                          <ClearIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider component="li" />
                  </>
                );
              })}
            </List>
          </Paper>
        )}
      </div>
    </>
  );
}

export default TeamPicker;
